import * as DropdownMenu from "@radix-ui/react-dropdown-menu";

import React from "react";
import {cn} from "../lib/utils";
import {useTranslation} from "react-i18next";

const Dropdown = ({children}: {children: React.ReactNode}) => {
  const {t} = useTranslation();

  return <DropdownMenu.Root>
    <DropdownMenu.Trigger asChild>{children}</DropdownMenu.Trigger>
    <DropdownMenu.Portal>
      <DropdownMenu.Content
        align="end"
        className="bg-white z-40 w-48 rounded-2xl shadow-lg py-2 flex flex-col"
      >
        {[
          {
            title: t("recipe_details.navigation_menu_to_be_removed.account.title"),
            href: t("recipe_details.navigation_menu_to_be_removed.account.href")
          },
          {
            title: t("recipe_details.navigation_menu_to_be_removed.logout.title"),
            href: t("recipe_details.navigation_menu_to_be_removed.logout.href")
          },
        ].map(({title, href}) => <DropdownMenu.Item
          textValue={href}
          className="px-6"
          key={title}
          asChild
        >
          <a
            href={href}
            className={cn([
              "text-sm font-semibold uppercase tracking-wide leading-10 text-green-900 outline-none",
              "hover:bg-green-900/10 focus-visible:bg-green-900/10 hover:text-green-700 focus-visible:text-green-700",
              "active:bg-green-900 active:text-white",
            ])}
          >
            {title}
          </a>
        </DropdownMenu.Item>)}
      </DropdownMenu.Content>
    </DropdownMenu.Portal>
  </DropdownMenu.Root>;
};

export {Dropdown};
